import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'

import { httpOk, GET, POST, PUT, FILE } from 'helpers/api'
import { formatDate } from "helpers/helpers"
import { toast } from "react-toastify"

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)

	async function searchWithFilter() {
		var filterUrl = "/poses"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/poses', selectedItem, { loader: true })
		} else {
			response = await POST('/poses', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			toggleModal(false)
			searchWithFilter()
		}
	}

	async function fileUpload(e) {
		const file = e.target.files[0];

		if (file) {
			const imgSize = file.size / (1024 * 1024);

			if (imgSize > 25) { // Проверка, если размер больше 25 МБ
				toast.error("Размер файла не должен превышать 25 МБ.");
				return;
			}

			// Используем промис для обработки загрузки изображения
			// const validateImage = () => {
			// 	return new Promise((resolve, reject) => {
			// 		const reader = new FileReader();
			// 		reader.onload = (event) => {
			// 			const img = new Image();
			// 			// img.onload = () => {
			// 			// 	const imgWidth = img.width;
			// 			// 	const imgHeight = img.height;

			// 			// 	if (imgWidth < 800 || imgHeight < 600) {
			// 			// 		reject(new Error("Минимальный размер 800x600 px"));
			// 			// 	} else {
			// 			// 	}
			// 			// };
			// 			img.onerror = () => reject(new Error("Failed to load image"));
			// 			img.src = event.target.result;
			// 		};
			// 		reader.onerror = () => reject(new Error("Failed to read file"));
			// 		reader.readAsDataURL(file);
			// 	});
			// };

			try {
				// Ждем завершения валидации изображения
				// await validateImage();

				// Если прошла валидация, формируем данные и отправляем запрос
				let formData = new FormData();
				// if (selectedItem.id) formData.append("id", selectedItem.id);
				formData.append("image", file);
				formData.append("db_name", 'poses');
				formData.append("column_name", 'image');
				formData.append("path", 'poses');

				let response;
				// selectedItem.id
				if (!false) {
					response = await FILE('/upload-image', formData, {}, { loader: true });
				} else {
					response = await FILE(`/update-image`, formData, {}, { loader: true });
				}

				if (httpOk(response)) {
					setSelectedItem({ ...selectedItem, logo: response.data.url });
				}
			} catch (error) {
				toast.error(error.message);
			}
		}
	}


	function toggleModal(bool, item = {}) {
		if (bool) setSelectedItem(item)

		setShowModal(bool)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('poses')} [{data.length}]
				</h4>
				{/* <div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div> */}
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }}>{t('phone')}</th>
									<th style={{ 'width': '20%' }}>{t('address')}</th>
									<th style={{ 'width': '20%' }}>{t('telegram')} ID</th>
									<th style={{ 'width': '20%' }}>{t('telegram_group_id')}</th>
									<th style={{ 'width': '8%' }} className="text-center">{t('date')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.name}</td>
										<td>{item.phone}</td>
										<td>{item.address}</td>
										<td>{item.telegram_bot_token}</td>
										<td>{item.telegram_group_id}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('logo')}</label>
							<div className="con-upload">
								<div className="con-img-upload">
									{selectedItem.logo &&
										<div className="img-upload">
											<button type="button" className="btn-x-file" onClick={() => setSelectedItem({ ...selectedItem, 'logo': '' })}>
												<i className="uil-times"></i>
											</button>
											<img src={`https://backend.tameer.uz/uploads/poses/${selectedItem.logo}`}
												style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} alt={selectedItem.logo} />
										</div>
									}
									{!selectedItem.logo &&
										<div className="con-input-upload">
											<input type="file" onChange={(e) => fileUpload(e)} />
											<span className="text-input fz14">
												{t('image2')}
											</span>
										</div>
									}
								</div>
							</div>
						</div>

						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('phone')}</label>
							<input type="text" className="form-control" name="phone"
								value={selectedItem.phone ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('address')}</label>
							<input type="text" className="form-control" name="address"
								value={selectedItem.address ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'address': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('qr_code')}</label>
							<input type="text" className="form-control" name="promotion_url"
								value={selectedItem.promotion_url ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'promotion_url': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('telegram_bot')} TOKEN</label>
							<input type="text" className="form-control" name="telegram_bot_token"
								value={selectedItem.telegram_bot_token ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'telegram_bot_token': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('telegram_group_id')}</label>
							<input type="text" className="form-control" name="telegram_group_id"
								value={selectedItem.telegram_group_id ?? ""}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'telegram_group_id': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index